import { MetricTooltip, splitTime } from '@devd-client/devd/components';

export const formatTimeUnit = (
  value: number,
  unit: 'Days' | 'Minutes' | 'Count' | 'Percentage'
) => {
  if (unit === 'Days') {
    return `${value} Days/Week`;
  }

  if (unit === 'Minutes') {
    return splitTime(value / 60);
  }

  if (unit === 'Count') {
    return value;
  }
  if (unit === 'Percentage') {
    return `${value}%`;
  }

  // For Count type
  return `${value} ${unit || ''}`;
};

export const getCompleteMetricList = (
  processedMetrics: MetricTooltip[] = []
) => {
  const hardcodedMetrics = [
    {
      title: 'Git Activity',
      metric: 'GIT_ACTIVITY',
      id: 'GIT_ACTIVITY',
    },
    {
      title: 'Issue Activity',
      metric: 'ISSUE_ACTIVITY',
      id: 'ISSUE_ACTIVITY',
    },
    {
      title: 'DORA Activity',
      metric: 'DORA_ACTIVITY',
      id: 'DORA_ACTIVITY',
    },
    {
      title: 'AI Adoption',
      metric: 'AI_ADOPTION',
      id: 'AI_ADOPTION',
    },
    {
      title: 'Goals',
      metric: 'GOALS',
      id: 'GOALS',
    },
    {
      title: 'Key Results',
      metric: 'KEY_RESULTS',
      id: 'KEY_RESULTS',
    },
  ];

  return [...processedMetrics, ...hardcodedMetrics];
};
